import React from 'react';
import ReactModal from 'react-modal';
import { defineMessages, FormattedMessage, 
    // intlShape, 
    injectIntl } from 'react-intl';
import { Icon } from 'antd';
import './drawerComponents.css';
import bindAll from 'lodash.bindall';
import wifiConnectSuccess from './wifiConnectSuccess.png'


const messages = defineMessages({
});

// wifi连接

class WifiConnectLoadModal extends React.Component {

    constructor(props) {
        super(props);
        bindAll(this, [
        ]);
    }

    componentDidMount() {
    }
    render() {
        const { intl, ...props } = this.props;
        return (
            <ReactModal 
                isOpen
                overlayClassName="modalOverlay"
                className="modalContentLoad"
                ariaHideApp={false}
            >
                <div>
                    <div className="wifiConnectLoad">
                        <img src={wifiConnectSuccess} />
                        <div className="wifiConncetWord">
                            <FormattedMessage
                                defaultMessage="Successfully connected"
                                description="Successfully connected"
                                id="gui.homePage.camNousWifiConnectSuccess"
                            />
                        </div>
                    </div>
                </div>
            </ReactModal>
        );
    }
}
WifiConnectLoadModal.propTypes = {
    // intl: intlShape
};

export default injectIntl(WifiConnectLoadModal);
